
/**
 * @public
 */
export enum DocumentType {
  Word = 1,
  Excel = 2,
  PowerPoint = 3,
  OneNote = 4,
  ExcelSurvey = 5,
  Text = 6,
  ExcelForm = 7,
  Visio = 8,
  Bohemia = 9,
  Prague = 10
}
